module.exports = __webpack_public_path__ + "img/asian-chicken-broccoli-2.7765880e.jpg";